<div class="px-3 mt-5">
   

    <div class="row g-4 mb-5 pb-5 d-flex justify-content-center">
        <div class="col-md-3 col-sm-6">
            <div class="card text-center bg-white p-4 rounded">
            <i class="fi fi-rr-hamburger-soda mb-3 size"></i>
            <h3 class="fs-2 fw-bold">{{ProductCount}}</h3>
            <p class="text-muted mb-0">კერძების რაოდენობა</p>
            </div>
        </div>

        <div class="col-md-3 col-sm-6">
            <div class="card text-center bg-white p-4 rounded">
            <i class="fi fi-rr-order-history mb-3 size"></i>
            <h3 class="fs-2 fw-bold">{{OrderCount}}</h3>
            <p class="text-muted mb-0">შეკვეთები</p>
            </div>
        </div>

        <div class="col-md-3 col-sm-6">
            <div class="card text-center bg-white p-4 rounded">
            <i class="fi fi-rs-sack-dollar mb-3 size"></i>
            <h3 class="fs-2 fw-bold">0</h3>
            <p class="text-muted mb-0">შემოსული თანხა</p>
            </div>
        </div>

        <!-- <div class="col-md-3 col-sm-6">
            <div class="card text-center bg-white p-4 rounded">
            <i class="fi fi-rr-users-alt mb-3 size"></i>
            <h3 class="fs-2 fw-bold">0</h3>
            <p class="text-muted mb-0">მომხმარებლები</p>
            </div>
        </div> -->



    </div>


    <div class="row mb-5 pb-5 d-flex justify-content-center">
        <div class="col-md-8">
            <div class="card p-3">
                <h5 class="text-center">ყველაზე ნახვადი პროდუქტები</h5>
                    <canvas baseChart
                    [data]="{ labels: barChartLabels, datasets: barChartData }"
                    [labels]="barChartLabels"
                    [options]="barChartOptions"
                    [type]="barChartType"
                    [plugins]="barChartPlugins"
                    [legend]="barChartLegend"
                    style="min-height: 300px;">
                    </canvas>
            </div>
        </div>

    </div>
</div>